import React from 'react'
import styled, { css } from 'styled-components'
import { useRevealProps } from '../../MwPage/components/Reveal'
import { Star } from '../../MwPage/icons'
import { ink, muted, sans, Section, Small, Stars } from '../../MwPage/styled'
import { useFocus } from '../focus'
import { Big, Card, Column, Wrap } from '../styled'

// one member's headline result, on a tinted card under the press strip
const Result = styled(Card)`
  display: flex;
  align-items: center;
  gap: 16px;

  ${Big} {
    font-size: 48px;
  }

  p {
    margin: 0;
    font: 700 16px/1.4 ${sans};
    color: ${ink};
  }
`

// a member's words on their own: stars, the quote, their name and the line under it, each given room
const Quote = styled(Card)`
  padding: clamp(28px, 4vw, 44px) clamp(24px, 4vw, 44px);

  ${Stars} {
    margin-bottom: 22px;
  }

  blockquote {
    margin: 0;
    font: 700 clamp(20px, 2.2vw, 26px) / 1.45 ${sans};
    letter-spacing: -0.015em;
    color: ${ink};
  }

  figcaption {
    margin-top: 24px;
    font: 700 clamp(18px, 2vw, 22px) / 1.3 ${sans};
    color: ${ink};
  }

  ${Small} {
    margin-top: 12px;
    font-size: 15px;
    color: ${muted};
  }

  ${(props) =>
    props.$centred &&
    css`
      @media (min-width: 761px) {
        text-align: center;

        ${Stars} {
          justify-content: center;
        }
      }
    `}
`

const FiveStars = ({ label }) => (
  <Stars aria-label={label}>
    {[0, 1, 2, 3, 4].map((n) => (
      <Star key={n} />
    ))}
  </Stars>
)

const ProofSection = () => {
  const { proof, testimonials, centred } = useFocus()
  const reveal = useRevealProps()

  if (!proof.big) {
    return (
      <Section style={{ padding: '26px 24px 8px' }}>
        <Wrap>
          <Column $max={820}>
            <Quote as="figure" $tint $centred={centred} {...reveal}>
              <FiveStars label={testimonials.starsLabel} />
              <blockquote>{proof.text}</blockquote>
              {proof.name && <figcaption>{proof.name}</figcaption>}
              <Small>{proof.sub}</Small>
            </Quote>
          </Column>
        </Wrap>
      </Section>
    )
  }

  return (
    <Section style={{ padding: '26px 24px 8px' }}>
      <Wrap>
        <Column $max={820}>
          <Result as="figure" $tint {...reveal}>
            <Big>{proof.big}</Big>
            <div>
              <FiveStars label={testimonials.starsLabel} />
              <p>{proof.text}</p>
              {proof.name && <Small style={{ marginTop: 2, fontWeight: 700 }}>{proof.name}</Small>}
              <Small style={{ marginTop: 2 }}>{proof.sub}</Small>
            </div>
          </Result>
        </Column>
      </Wrap>
    </Section>
  )
}

export default ProofSection
